import React, { useState } from 'react';
import {
  Wrench,
  Check,
  ChevronDown,
  ChevronUp,
  Cpu,
  Brain,
  ShieldAlert
} from 'lucide-react';

export default function AgentTrace({
  events = [],
  current_agent = 'supervisor'
}) {
  const [isOpen, setIsOpen] = useState(false);

  if (!events || events.length === 0) return null;

  return (
    <div className="border border-slate-200/80 bg-slate-50/70 rounded-xl overflow-hidden my-2 text-xs">
      {/* Clickable Header */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-3 py-2 flex items-center justify-between text-slate-600 hover:text-slate-900 transition-colors cursor-pointer"
      >
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded-md bg-blue-100 text-blue-700 flex items-center justify-center">
            <Cpu className="w-3 h-3" />
          </div>
          <span className="font-semibold text-[11px]">
            Autonomous Agent Coordination Trace ({events.length} steps)
          </span>
        </div>

        <div className="flex items-center gap-1.5 text-slate-400">
          <span className="text-[10px] font-mono">Agent: {current_agent}</span>
          {isOpen ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
        </div>
      </button>

      {/* Expanded Step Trace */}
      {isOpen && (
        <div className="p-3 pt-1 border-t border-slate-200/60 bg-white/60 space-y-2">
          {events.map((ev, idx) => {
            const isAgentStart = ev.type === 'agent_start';
            const isToolCall = ev.type === 'tool_call';
            const isApproval = ev.type === 'approval_required';

            return (
              <div key={idx} className="flex items-start gap-2 text-[11px]">
                <div className="shrink-0 mt-0.5">
                  {isAgentStart && <Brain className="w-3.5 h-3.5 text-blue-600" />}
                  {isToolCall && <Wrench className="w-3.5 h-3.5 text-emerald-600" />}
                  {isApproval && <ShieldAlert className="w-3.5 h-3.5 text-amber-600" />}
                  {!isAgentStart && !isToolCall && !isApproval && (
                    <Check className="w-3.5 h-3.5 text-slate-400" />
                  )}
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <span className="font-semibold text-slate-800 capitalize font-mono text-[10px]">
                      [{ev.agent || current_agent}]
                    </span>
                    {ev.tool && (
                      <code className="bg-slate-100 px-1 py-0.2 rounded font-mono text-[10px] text-slate-700">
                        {ev.tool}
                      </code>
                    )}
                  </div>
                  <p className="text-slate-600 mt-0.5 leading-relaxed font-sans">
                    {ev.text || (ev.arguments ? JSON.stringify(ev.arguments) : 'Step completed')}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
